import vm from '../main'

const internals = {}

internals.addtripException = function(tripException) {

    tripException = (({
        docId,
        prevDestination,
        divertedDestination,
        recordedTime,
        _id

    }) => {
        return {
            docId,
            prevDestination,
            divertedDestination,
            recordedTime,
            _id
        }
    })(tripException)

    return vm.$tripExceptionDataRepository
        .create(tripException)
        .then(result => {
            tripException = result.data
            return tripException
        })
        .catch(error => {
            console.error('tripExceptionService.createTripException-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/tripException.service.js